import { render, staticRenderFns } from "./has_send.vue?vue&type=template&id=7d2e20cf&scoped=true"
import script from "./has_send.vue?vue&type=script&lang=js"
export * from "./has_send.vue?vue&type=script&lang=js"
import style0 from "./has_send.vue?vue&type=style&index=0&id=7d2e20cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e20cf",
  null
  
)

export default component.exports